import { FontVariant } from "@/constants/theme";
import type { Theme } from "@/types/theme";

export function getFontValuesByFontVariant(
  theme: Pick<Theme, "fontSettings">,
  fontVariant: FontVariant,
) {
  switch (fontVariant) {
    case FontVariant.BodyXSmall:
      return theme.fontSettings.bodyXSmall;

    case FontVariant.BodySmall:
      return theme.fontSettings.bodySmall;

    case FontVariant.BodyRegular:
      return theme.fontSettings.bodyRegular;

    case FontVariant.BodyLarge:
      return theme.fontSettings.bodyLarge;

    case FontVariant.BodyXLarge:
      return theme.fontSettings.bodyXLarge;

    case FontVariant.BodyXXLarge:
      return theme.fontSettings.bodyXXLarge;

    case FontVariant.BulletPoints:
      return theme.fontSettings.bulletPoints;

    case FontVariant.PullQuote:
      return theme.fontSettings.pullQuote;

    case FontVariant.HeaderH1:
      return theme.fontSettings.headerH1;

    case FontVariant.HeaderH2:
      return theme.fontSettings.headerH2;

    case FontVariant.HeaderH3:
      return theme.fontSettings.headerH3;

    case FontVariant.HeaderH4:
      return theme.fontSettings.headerH4;

    case FontVariant.HeaderH5:
      return theme.fontSettings.headerH5;

    case FontVariant.HeaderH6:
      return theme.fontSettings.headerH6;

    default:
      return null;
  }
}
